// Phase 15 Plan 05 Task 3 — Net wrapper for GET /api/home (lobby/home batched payload).
//
// Thin wrapper over apiFetch. Re-exports the generated HomeResponse type so
// store/UI consumers can import the canonical wire shape from one place
// (vs. dragging the whole components['schemas'] chain through every call site).

import type { components } from '@runegambit/api-types'
import { apiFetch } from './client'

export type HomeResponse = components['schemas']['HomeResponse']
export type ActiveMatchPreview = components['schemas']['ActiveMatchPreview']
export type TournamentPreview = components['schemas']['TournamentPreview']

/**
 * GET /api/home — batched lobby/home payload.
 *
 * Returns the active-match list + active-match-count + cap (DEC-009), the
 * active-tournaments list, pending friend-request count, and bot-practice
 * availability flag. Caller is bearer-derived; no params.
 *
 * On 5xx, apiFetch retries once (250ms). On 401, apiFetch silent-refreshes
 * + retries once (500ms) then clearAuth + throws AuthInvalidError.
 */
export async function fetchHome(): Promise<HomeResponse> {
  return apiFetch<HomeResponse>('/api/home', 'GET')
}
